import styles from './SourceLink.module.css';

interface SourceLinkProps {
  /** Source name shown as the button label (e.g. "OSV.dev", "NVD"). */
  label: string;
  href: string;
}

/** External-source link styled as a compact button with an external-link icon. */
export function SourceLink({ label, href }: SourceLinkProps) {
  return (
    <a href={href} target="_blank" rel="noreferrer" className={styles.sourceLink}>
      {label}
      <svg
        className={styles.icon}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
        <polyline points="15 3 21 3 21 9" />
        <line x1="10" y1="14" x2="21" y2="3" />
      </svg>
    </a>
  );
}
